import React from 'react';
import ItemList from '../../../components/item-list/ItemList';

const UsersTable = ({
  users,
  selectedUsers,
  onSelectAll,
  onSelectUser,
  onToggleExpand,
  onDeleteSelected,
  onEdit,
  onViewFiles,
  onChangeStatus,
  canSelect = true,
  canDelete = true,
  canEdit = true,
  canChangeStatus = true,
  currentPage,
  onPageChange,
  totalItems,
  itemsPerPage = 10,
  isServerPaginated = true,
  loading = false
}) => {
  const columns = [
    { key: 'name', label: 'Full Name' },
    { key: 'email', label: 'Email' },
    { key: 'phone', label: 'Phone' },
    { key: 'company', label: 'Company Name' },
    { key: 'status', label: 'Status' },
    { key: 'actions', label: 'Actions' }
  ];

  return (
    <ItemList
      items={users}
      itemType="users"
      selectedItems={selectedUsers}
      onSelectAll={onSelectAll}
      onSelectItem={onSelectUser}
      onToggleExpand={onToggleExpand}
      onDeleteSelected={onDeleteSelected}
      onEdit={onEdit}
      onViewFiles={onViewFiles}
      onChangeStatus={onChangeStatus}
      canSelect={canSelect}
      canDelete={canDelete}
      canEdit={canEdit}
      canChangeStatus={canChangeStatus}
      currentPage={currentPage}
      onPageChange={onPageChange}
      columns={columns}
      totalItems={totalItems}
      itemsPerPage={itemsPerPage}
      isServerPaginated={isServerPaginated}
      loading={loading}
    />
  );
};

export default UsersTable;

